<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"> Master RPL 
      <CButton color="danger" style="float:right;margin-right:10px" class="btn-md ml-auto">Ekspor PDF</CButton>
     
      <CDropdown toggler-text="Ekspor Excel" color="warning" class="mr-2 d-inline-block text-white float-right">
        <CDropdownItem>Ekspor Semua</CDropdownItem>
        <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
      </CDropdown>
     
      <router-link :to="rpl_link_add">
        <CButton color="success" style="float:right" class="btn-md">Tambah</CButton>
      </router-link>
    
    </CCardHeader>
    <!-- Tabs -->
    
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-acpa"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('ACPA')"
          aria-controls="home"
          aria-selected="true">Workshop</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-cta"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('ACPA')"
          aria-controls="home"
          aria-selected="true">Test Center</router-link>
      </li>
      <!-- <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-acpa"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('ACPA')"
          aria-controls="home"
          aria-selected="true">ACPA</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-cta"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="tabchange('CTA')"
          aria-controls="profile"
          aria-selected="false" >CTA</router-link>
      </li>          

      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-rna"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          @click.native="tabchange('RNA')"
          aria-selected="false" >RNA</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-ppak"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          @click.native="tabchange('PPAK')"
          aria-selected="false" >PPAK</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-bpk"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          @click.native="tabchange('BPK')"
          aria-selected="false">BPK</router-link>
       
      </li>
      
      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-lainnya"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          @click.native="tabchange('RPL Lainnya')"
          aria-selected="false">RPL Lainnya</router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/sertifikasi/master-sertifikasi-rpl/master-rpl-instrukturrpl"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          @click.native="tabchange('Instruktur RPL')"
          aria-selected="false">Instruktur RPL</router-link>
      </li> -->
    </ul>

    <!-- Data RPL-->
    <router-view></router-view>
    <!-- End Data RPL -->
  </CCard>
</template>
<script>

export default {
  name: "Master Sertifikasi RPL",
  data() {
    return {
        title_tab : 'ACPA',
        rpl_link_add : '/sertifikasi/master-rpl-acpa/tambah'
    };
  },
  mounted() {
    this.mountedchange(this.$router.currentRoute.path)
  },
  watch: {
    
  },
  methods: {
      tabchange(value) {
          
          this.title_tab = value;
          switch (value) {
            case 'ACPA':
                this.rpl_link_add = '/sertifikasi/master-rpl-acpa/tambah'
                break;
            case 'CTA':
                this.rpl_link_add = '/sertifikasi/master-rpl-cta/tambah'
                break;
            case 'RNA':
                this.rpl_link_add = '/sertifikasi/master-rpl-rna/tambah'
                break;
            case 'PPAK':
                this.rpl_link_add = '/sertifikasi/master-rpl-ppak/tambah'
                break;
            case 'BPK':
                this.rpl_link_add = '/sertifikasi/master-rpl-bpk/tambah'
                break;
            case 'CPAI':
                this.rpl_link_add = '/sertifikasi/master-rpl-cpai/tambah'
                break;
            case 'RPL Lainnya':
                this.rpl_link_add = '/sertifikasi/master-rpl-lainnya/tambah'
                break;
            case 'Instruktur RPL':
                this.rpl_link_add = '/sertifikasi/master-rpl-instrukturrpl/tambah'
                break;
              default:
                  break;
          }
      },
      mountedchange(value) {
        switch (value) {
            case '/sertifikasi/master-sertifikasi-rpl/master-rpl-workshop':
                this.rpl_link_add = '/sertifikasi/master-rpl-acpa/tambah'
                this.title_tab = 'ACPA';
                break;
            case '/sertifikasi/master-sertifikasi-rpl/master-rpl-cta':
                this.rpl_link_add = '/sertifikasi/master-rpl-cta/tambah'
                this.title_tab = 'CTA';
                break;
            case '/sertifikasi/master-sertifikasi-rpl/master-rpl-rna':
                this.rpl_link_add = '/sertifikasi/master-rpl-rna/tambah'
                this.title_tab = 'RNA';
                break;
            case '/sertifikasi/master-sertifikasi-rpl/master-rpl-ppak':
                this.rpl_link_add = '/sertifikasi/master-rpl-ppak/tambah'
                this.title_tab = 'PPAK';
                break;
            case '/sertifikasi/master-sertifikasi-rpl/master-rpl-bpk':
                this.rpl_link_add = '/sertifikasi/master-rpl-bpk/tambah'
                this.title_tab = 'CTA';
                break;
            case '/sertifikasi/master-sertifikasi-rpl/master-rpl-cpai':
                this.rpl_link_add = '/sertifikasi/master-rpl-cpai/tambah'
                this.title_tab = 'CPAI';
                break;
            case '/sertifikasi/master-sertifikasi-rpl/master-rpl-lainnya':
                this.rpl_link_add = '/sertifikasi/master-rpl-lainnya/tambah'
                this.title_tab = 'RPL Lainnya';
                break;
            case '/sertifikasi/master-sertifikasi-rpl/master-rpl-instrukturrpl':
                this.rpl_link_add = '/sertifikasi/master-rpl-instrukturrpl/tambah'
                this.title_tab = 'Instruktur RPL';
                break;
           
            default:
                break;
        }
      }
  }
};
</script>